import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const OutboundFileIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 21L13 18.5L15.5 16M13 18.5H19M13 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H9.5M13 3H13.586C13.851 3 14.105 3.105 14.293 3.293L18.707 7.707C18.895 7.895 19 8.149 19 8.414V9M13 3V7C13 8.105 13.895 9 15 9H19M19 9V13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

OutboundFileIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(OutboundFileIcon);
